export default __webpack_public_path__ + "static/O0083-3a47f55ab296839ad119e4615b3c2c32.png";